import { InjectionToken } from '@angular/core';
import { MethodType } from '../entities/methodtype.model';

export const METHODTYPE_SERVICE = new InjectionToken<MethodTypeRepository>('METHODTYPE_SERVICE');
export interface MethodTypeRepository {
  findForSample(sampleId: string): Promise<MethodType>;
}
